import colors from "../../../Constants/colors";
import theme, { scrollbarStyles } from "../../../Constants/theme";

export const ContactUsContainerStyles = {
  display: "flex",
  bgcolor: theme.backgroundColors.dark.primary,
  flexDirection: "column",
  padding: "20px",
  width: "100%",
  height: "100vh",
  color: theme.textColors.dark.primary,
};

export const ContactUsPaperStyles = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  backgroundColor: theme.backgroundColors.dark.tertiary,
  my: "40px",
  padding: 6,
  overflowY: "hidden",
  height: "90vh",
};

export const contentScroll = {
  px: 2,
  overflowY: "auto",
  ...scrollbarStyles,
};

export const textfieldLayout = {
  backgroundColor: colors.extremeWhite,
  borderRadius: "5px",
  // boxShadow: `0px 4px 12px ${colors.secondaryBlue}`,
  "& .MuiInputBase-input": {
    color: colors.extremeBlack, // Ensure the text color inside the input is white
  },
  "& .MuiInputLabel-root.Mui-focused": {
    fontSize: "1.25rem",
    color: colors.extremeBlack,
  },
  "& .MuiInputLabel-root": {
    color: colors.extremeBlack,
    fontSize: "1rem",
  },
  border: `1px solid ${colors.primaryBlue}`,
  "& .MuiFilledInput-input.Mui-disabled": {
    color: colors.extremeBlack, // Text color when disabled
  },
};

export const selectBaseStyles = {
  backgroundColor: colors.extremeWhite,
  border: `1px solid ${colors.primaryBlue}`,
  width: "100%",
  borderRadius: "5px",
  // boxShadow: `0px 4px 12px ${colors.secondaryBlue}`,
  color: colors.extremeBlack,
  "& .MuiSelect-icon": {
    color: colors.extremeBlack,
  },
  "& .MuiInputBase-input": {
    color: colors.extremeBlack,
  },
  "& .Mui-focused .MuiInputLabel-root": {
    color: colors.extremeBlack,
  },
  "&:before, &:after": {
    border: `1px solid ${colors.primaryBlue}`,
  },
};

export const menuItemStyles = {
  backgroundColor: "transparent",
  color: colors.extremeWhite,
  fontWeight: "normal",
  "&:hover": {
    backgroundColor: colors.primaryBlue,
    color: colors.extremeWhite,
  },
  "&.Mui-selected": {
    backgroundColor: `${colors.secondaryBlue} !important`,
    color: `${colors.extremeWhite} !important`,
    "&:hover": {
      backgroundColor: `${colors.primaryBlue} !important`,
      color: `${colors.extremeWhite} !important`,
    },
  },
};

export const menuContainerStyles = {
  backgroundColor: colors.extremeBlue,
  // boxShadow: `0px 4px 12px ${colors.primaryBlue}`,
  opacity: 1,
  backdropFilter: "none",
};
